import Env from '../base/env.js';
import gsap from 'gsap'

export default class FullscreenSticky
{
  constructor(view)
  {
    this.view = view
    this.$fullscreens = this.view.querySelectorAll('.jsFullscreen--view')
    this.scaleValue = .1
    this.elements = []
    this.raf = false
  }

  animate()
  {
    this.getElements()
    this.watch()
  }

  destroy()
  {
    cancelAnimationFrame(this.raf)
  }

  getElements()
  {
    for(let $full of this.$fullscreens) {
      this.elements.push({ ref : $full, img : $full.querySelector('img') })
    }
  }

  watch()
  {
    this.raf = requestAnimationFrame(()=>{
      this.watch()
      for(let element of this.elements) {
        const viewport = Env.framework.toolbox.getViewport()
        // Pos X
        const coordItem = element.ref.getBoundingClientRect()
        const diffX = viewport.width - coordItem.x
        const newPosX = viewport.width - diffX
        // Scale
        let ratio = diffX / (viewport.width / 2)
        if(ratio > 2) {
          ratio = 2
        } else if(ratio < 0) {
          ratio = 0
        }
        const scale = this.scaleValue * ratio
        // Animate
        let newScaleValue = 1.2 - scale
        if(newScaleValue <= 1) {
          newScaleValue = 1
        }
        gsap.set(element.img , { scale : newScaleValue })
      }
    })
  }
}
